import type { LoaderFunctionArgs } from 'react-router-dom'
import { DurationTestStatus, DefaultFetchDeviceFilters } from '@/api/definition'
import { fetchDevicePageApi } from '@/api/devicePageApi'
import { Device } from '@/pages/Device/Device'

export interface CalibrationLoaderData {
  initialDevices: Device[]
  rowCount: number
  error?: string
}

export async function calibrationLoader(
  _args: LoaderFunctionArgs,
): Promise<CalibrationLoaderData> {
  try {
    const result = await fetchDevicePageApi(
      {
        ...DefaultFetchDeviceFilters,
        inService: true,
        durationTestStatus: [DurationTestStatus.DurationTestNotStarted],
      },
      {
        pageIndex: 0,
        pageSize: 10,
        sortBy: [],
        globalFilter: '',
        selectedFilters: {},
      },
      false,
    )

    const initialDevices = result.data?.length
      ? result.data.map((device) => ({ ...device, id: device.uid }))
      : []

    return {
      initialDevices,
      rowCount: result.rowCount ?? 0,
    }
  } catch (error) {
    console.error('Failed to load calibration device data:', error)
    return {
      initialDevices: [],
      rowCount: 0,
      error: 'Failed to load calibration device data',
    }
  }
}
